import { AuthenticateWithRedirectCallback } from "@clerk/clerk-react";

export default function SSOCallback() {
  return (
    <AuthenticateWithRedirectCallback
      signInForceRedirectUrl="/login?clerk=ready"
      signUpForceRedirectUrl="/login?clerk=ready"
    />
  );
}
